import { Avatar, AvatarFallback, AvatarImage } from '@cibli/shared';
import { Camera } from 'lucide-react';

import { useCVTranslation } from '@/features/cv/hooks/useCVTranslation.ts';

interface ProfilePictureProps {
  imageBase64?: string | null;
  firstName?: string;
  lastName?: string;
  size?: 'sm' | 'lg';
  showPlaceholder?: boolean;
  onClick?: () => void;
  textColor?: 'text-black' | 'text-primary' | 'text-white';
}

const ProfilePicture = ({
  imageBase64 = null,
  firstName = '',
  lastName = '',
  size = 'lg',
  showPlaceholder = true,
  onClick,
  textColor = 'text-black',
}: ProfilePictureProps) => {
  const { t } = useCVTranslation();

  const avatarSize = size === 'sm' ? 'w-32 h-32' : 'w-64 h-64';
  const cameraIconSize = size === 'sm' ? 'h-8 w-8' : 'h-16 w-16';
  const textSize = size === 'sm' ? 'text-sm' : 'text-lg';

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div className="flex flex-col items-center">
      {imageBase64 ? (
        <Avatar className={`${avatarSize} mx-auto`} onClick={handleClick}>
          <AvatarImage src={imageBase64} alt="Profile" />
          <AvatarFallback>
            {firstName?.[0] || ''}
            {lastName?.[0] || ''}
          </AvatarFallback>
        </Avatar>
      ) : showPlaceholder ? (
        <div
          className={`${avatarSize} p-4 bg-primary/10 rounded-full flex flex-col items-center  justify-center ${onClick ? 'cursor-pointer' : ''} ${textColor}`}
          onClick={handleClick}
        >
          <Camera className={`${cameraIconSize} ${textColor}`} />
          <p className={`mt-2 ${textSize} ${textColor} text-center`}>
            {t('CV.PersonalInfo.takePhoto')}
          </p>
        </div>
      ) : null}
    </div>
  );
};

export default ProfilePicture;
